import { render, staticRenderFns } from "./schoolComplaints.vue?vue&type=template&id=707718ac&scoped=true&"
import script from "./schoolComplaints.vue?vue&type=script&lang=js&"
export * from "./schoolComplaints.vue?vue&type=script&lang=js&"
import style0 from "./schoolComplaints.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./schoolComplaints.vue?vue&type=style&index=1&id=707718ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707718ac",
  null
  
)

export default component.exports